import { Link } from "@tanstack/react-router";

export function NotFound({ children }: { children?: React.ReactNode }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-6 px-4 text-center md:px-8">
      <h1 className="font-display text-4xl font-bold text-charcoal">404</h1>
      <div className="font-body text-gray-80">
        {children || <p>The page you are looking for does not exist.</p>}
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={() => window.history.back()}
          className="rounded border-2 border-teal-dark px-4 py-2 font-body text-sm font-semibold text-teal-dark"
        >
          Go back
        </button>
        <Link to="/" className="rounded bg-teal-cta px-4 py-2 font-body text-sm text-white transition-colors hover:bg-teal-cta-hover">
          Home
        </Link>
      </div>
    </div>
  );
}
